import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    paper: {
      fontSize: '12px !important',    
    }
  });

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

///const optionsABC = [{"id":1,"title":"CUET"},{"id":2,"title":"Engineering"},{"id":3,"title":"Medical"},{"id":4,"title":"Management"}];

export default function Asynchronous(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState(props.options);
  const [autoId, setAutoId] = React.useState(0);
  const [title, setTitle] = React.useState("");
  const loading = open && options.length === 0; 

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3); 
      if (active) {
            setOptions(props.options);
            // axios.get(props.flag=='Topic'?API_URL+'/coursestopics?templateId='+props.templateId:API_URL+'/courseskeywords?templateId='+props.templateId)
            // .then(response => {
            // ///console.log("Just Checking >> "+response.data);  
            // ///setTreeViewData(response.data);	
            //   setOptions(response.data);   
            // })  
      }
    })();

    return () => {
      active = false;
    };
  }, [props.options,loading]);

  React.useEffect(() => { //setApiData
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  function selectedValue(obj,val){
    if(obj){
        if(obj.title){
          setAutoId(obj.autoId);
          setTitle(obj.title); 
          props.toCallParentMethod(obj,obj.title);
        }  
    }else if(val && val!==title){
      props.toCallParentMethod(0,val);
    }     
  }

  const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: option => option.title,
  });

  return (
      <Autocomplete
            //defaultValue={options?options[0]:null}
            defaultValue={props.defaultValue?props.defaultValue:null}
            id="search-input-topicbox"
            freeSolo={props.freeSolo}
            classes={{ paper: classes.paper }}
            sx={{ width: '100%', backgroundColor: '#FFF' }}            
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
            }}
            isOptionEqualToValue={(option, value) => option.title === value.title}
            getOptionLabel={(option) => option.title}
            options={options}
            loading={loading}
            filterOptions={filterOptions}
            onChange={(event, myObj) => selectedValue(myObj,event.target.value)}
            onBlur={(event, myObj) => selectedValue(myObj,event.target.value)}
            renderInput={(params) => (
              <TextField 
                {...params}
                label={props.label} 
                size='small'
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
                
              />
            )}
      />
  );
}

